export const restBulkCacheKeys = {
  createBulk: () => ['bulk_create_shifts'] as const,
  deleteBulk: () => ['bulk_delete_shifts'] as const
}

export const restCacheKeys = {
  getRest: queryParams => ['fetch_rest', queryParams]
}
